<div class="radio-field">
  <input
    type="radio"
    class="radio"
    tabindex="0"
    [name]="group"
    [value]="value"
    [formControl]="fieldControl"
    [attr.id]="fieldId"
    [attr.data-e2e-id]="e2eId"
  />

  <label
    class="radio-label"
    [ngClass]="{ 'hidden-label': hideLabel, disabled: fieldControl?.disabled }"
    [attr.for]="fieldId"
    (click)="onRadioClick($event)"
  >
    <span *ngIf="label" [ngClass]="{ 'sr-text': hideLabel }">
      {{ label }}
    </span>
  </label>
</div>

<p *ngIf="description" class="description">
  {{ description }}
</p>
